import React from 'react';
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["Software Engineer.", "Full Stack Developer.", "Professional Coder."],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-normal">WELCOME TO MY WORLD</h4>
        {/* <h1 className="text-6xl font-bold text-white">
  Hi, I'm <span className="text-gray-400 capitalize">Sai Rajesh Jaini</span>
</h1> */}

        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-teal-400 capitalize">Sai Rajesh Jaini</span>
        </h1>
        {/* <h1 className="text-6xl font-bold text-white">
  Hi, I'm <span className="text-indigo-400 capitalize">Sai Rajesh Jaini</span>
</h1> */}
{/* <h1 className="text-6xl font-bold text-white">
  Hi, I'm <span className="text-emerald-400 capitalize">Sai Rajesh Jaini</span>
</h1> */}
{/* <h1 className="text-6xl font-bold text-white">
  Hi, I'm <span className="text-gray-400 capitalize">Sai Rajesh Jaini</span>
</h1> */}


        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#38b2ac"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          I am deeply passionate about software engineering, driven by a love for problem-solving 
          and a relentless pursuit of excellence. My positive attitude and growth mindset fuel my 
          commitment to continuous learning and innovation. I thrive on tackling complex challenges, 
          turning ideas into impactful solutions, and contributing meaningfully to team success.
        </p>
      </div>
     {/* Media */}
     <Media />
    </div>
  );
}

export default LeftBanner;
